export default __webpack_public_path__ + "static/media/instagram-yellow.7d3b1c22.svg";